var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTowerCameraThermal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 19,
    viewBox: "0 0 10 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 18.8435C3.61667 18.8435 2.4375 18.356 1.4625 17.381C0.4875 16.406 0 15.2268 0 13.8435C0 13.0435 0.175 12.2977 0.525 11.606C0.875 10.9143 1.36667 10.3268 2 9.84351V3.84351C2 3.01017 2.29167 2.30184 2.875 1.71851C3.45833 1.13517 4.16667 0.843506 5 0.843506C5.83333 0.843506 6.54167 1.13517 7.125 1.71851C7.70833 2.30184 8 3.01017 8 3.84351V9.84351C8.63333 10.3268 9.125 10.9143 9.475 11.606C9.825 12.2977 10 13.0435 10 13.8435C10 15.2268 9.5125 16.406 8.5375 17.381C7.5625 18.356 6.38333 18.8435 5 18.8435ZM5 16.8435C5.83333 16.8435 6.54167 16.5518 7.125 15.9685C7.70833 15.3852 8 14.6768 8 13.8435C8 13.3602 7.89583 12.9102 7.6875 12.4935C7.47917 12.0768 7.18333 11.7268 6.8 11.4435L6 10.8435V3.84351C6 3.56017 5.90417 3.32267 5.7125 3.13101C5.52083 2.93934 5.28333 2.84351 5 2.84351C4.71667 2.84351 4.47917 2.93934 4.2875 3.13101C4.09583 3.32267 4 3.56017 4 3.84351V10.8435L3.2 11.4435C2.81667 11.7268 2.52083 12.0768 2.3125 12.4935C2.10417 12.9102 2 13.3602 2 13.8435C2 14.6768 2.29167 15.3852 2.875 15.9685C3.45833 16.5518 4.16667 16.8435 5 16.8435Z",
    fill: "#FF0953"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTowerCameraThermal);
export default __webpack_public_path__ + "static/media/tower_camera_thermal.16f508dfb708a47f75da99474d2f1df3.svg";
export { ForwardRef as ReactComponent };